
import '../app';

import '../../styles/index.css'

import "babel-polyfill"

import 'lazysizes';

// import gsap from "gsap";
// import CSSRulePlugin from 'gsap/CSSRulePlugin';
// import ScrollTrigger from "gsap/ScrollTrigger";
// import ScrollToPlugin from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

const fadeSections = gsap.utils.toArray("[data-fade-section]");
const fadeInElements = gsap.utils.toArray("[data-fade-in]");
const fadeLeftElements = gsap.utils.toArray("[data-fade-left]");
const fadeBodyBg = gsap.utils.toArray("[data-color]");
const header = document.querySelectorAll('.header');
const imageContainers = gsap.utils.toArray(".image-container")
const fadeInTitle = gsap.utils.toArray("[data-fade-title]");
const showVideoOverlay = document.querySelector('#show-video-overlay');
const closeVideoOverlay = document.querySelector('#close-video-modal');
const videoOverlay = document.querySelector('.video-overlay');
const videoElem = document.getElementById("watch-now-teaser");
const closeVideoModal = document.getElementById("close-video-modal");
const heroVideo = document.querySelector('#hero-video');
const mobileHeroVideo = document.querySelector('#hero-video-mobile');
const swatches = document.querySelectorAll('.swatch');

let imageTl = gsap.timeline()
let beyondImageTl = gsap.timeline()

const heroCopy = gsap.utils.selector("[data-fade-title]");
let elemsInHeroCopy = heroCopy('h1, h2');

// listener for when hero video ends
// tie gsap animation to this for title

var callOnceDesktop = true;
var callOnceMobile = true;

function monitorDesktopVideo() {
  if ((heroVideo.duration - heroVideo.currentTime) < 3) {
    if (callOnceDesktop) {
      fadeHeroElementsIn()
      callOnceDesktop = false;
    }
  }
}

function monitorMobileVideo() {
  if ((mobileHeroVideo.duration - mobileHeroVideo.currentTime) < 3) {
    if (callOnceMobile) {
      fadeHeroElementsIn()
      callOnceMobile = false;
    }
  }
}


setInterval(monitorDesktopVideo, 100);
setInterval(monitorMobileVideo, 100);

/////////////

document.body.classList.add('u-no-focus-outline')

document.body.addEventListener('keyup', function (event) {
  /* if key is tab */
  if (event.which === 9) {
    document.body.classList.remove('u-no-focus-outline')
    document.body.classList.add('u-focus-outline')
  }
})


// heroVideo.addEventListener('ended', function() {

function fadeHeroElementsIn() {
  elemsInHeroCopy.forEach(function (elem) {
      gsap.to( elem, 1, {
        opacity: 1,
        visibility: 'visible',
        y: 0,
        ease: "power4.out",
        stagger: {
          amount: .03
        }
      });
  })
}

// mobileHeroVideo.addEventListener('ended', function() {

//   elemsInHeroCopy.forEach(function (elem) {
//       gsap.to( elem, 1, {
//         opacity: 1,
//         visibility: 'visible',
//         y: 0,
//         ease: "power4.out",
//         stagger: {
//           amount: .03
//         }
//       });
//   })
// })

//////////////////////////////////////////////////
//////////////////////////////////////////////////

// scrolltrigger for fade-in animations

fadeInElements.forEach(function (elem) {
  ScrollTrigger.create({
    autoAlpha: 0,
    trigger: elem,
    start: "top 60%",
    end: "bottom 20%",

    onEnter: function () {

      gsap.to( elem, 1, {
        opacity: 1,
        y: 0,
        ease: "power4.out",
        stagger: {
          amount: .03
        }
      }
      );
    },
  });
});

//////////////////////////////////////////////////
//////////////////////////////////////////////////

// scrolltrigger for fade-left animations

fadeLeftElements.forEach(function (elem) {
  ScrollTrigger.create({
    autoAlpha: 0,
    trigger: elem,
    start: "top 60%",
    end: "bottom 20%",

    onEnter: function () {
      gsap.to( elem, 1, {
        opacity: 1,
        x: 0,
        ease: "power4.out",
        stagger: {
          amount: .03
        }
      }
      );
    },
  });
});

//////////////////////////////////////////////////
//////////////////////////////////////////////////

// scrolltrigger for background color fade

fadeBodyBg.forEach((elem, i) => {
  const prevColor = i === 0 ? "#191919" : fadeBodyBg[i - 1].dataset.color;
  ScrollTrigger.create({
    // markers: true,
    trigger: elem,
    start: "top center",
    onEnter: () => {
      gsap.to("body", {backgroundColor: elem.dataset.color, overwrite: 'auto'});
    },
    onLeaveBack: () => gsap.to("body", {backgroundColor: prevColor, overwrite: 'auto'})
  });
});

//////////////////////////////////////////////////
//////////////////////////////////////////////////

// scrolltrigger animations for images in beyond comfort/beyond mesh

imageContainers.forEach(function (elem) {
  ScrollTrigger.create({
    autoAlpha: 0,
    trigger: elem,
    start: "top 60%",
    end: "bottom 20%",
    // markers: true,
    once: true,
    onEnter: function (e) {

      let image = e.trigger.childNodes[3];
      let imageReveal =  e.trigger.childNodes[1];

      imageTl.to(elem, 0, { css: { visibility: "visible" } });
      imageTl.to(imageReveal, 1.4, { height: "0%", ease: Power2.easeInOut });
      imageTl.from(image, 1.4, {
        scale: 1.6,
        ease: "Power2.easeInOut",
        delay: -1.4,
        scrub: true,
      });
    }
  });
});

//////////////////////////////////////////////////
//////////////////////////////////////////////////

// toggles video modal

showVideoOverlay.addEventListener('click', () => {
  videoOverlay.classList.add('is-open');
  playVideo()
  // lock body when modal is show
  document.body.style.overflow = 'hidden';
});

closeVideoOverlay.addEventListener('click', () => {
  videoOverlay.classList.remove('is-open');

  // allow scroll when modal is closed
  const scrollY = document.body.style.top;
  document.body.style.overflow = 'auto';
});

// video modal pause + play

closeVideoModal.addEventListener("click", pauseVideo, false);

function pauseVideo() {
    videoElem.pause();
    videoElem.currentTime = 0;
}

function playVideo() {
  videoElem.muted = false;
  videoElem.play();
}

/////////////

//////////////////////////////////////////////////
//////////////////////////////////////////////////

/// swatch slider

var Flickity = require('flickity-hash');
require('flickity-fade');

var flkty1 = new Flickity( '.carousel--1', {
    pageDots: false,
    prevNextButtons: false,
    draggable: false,
    hash: true,
    fade: true,
});

var flkty2 = new Flickity( '.carousel--2', {
    pageDots: false,
    prevNextButtons: false,
    draggable: false,
    hash: true,
    fade: true,
});

var flkty3 = new Flickity( '.carousel--3', {
    pageDots: false,
    prevNextButtons: false,
    draggable: false,
    hash: true,
    fade: true,
});

var flkty4 = new Flickity( '.carousel--4', {
    pageDots: false,
    prevNextButtons: false,
    draggable: false,
    hash: true,
    fade: true,
});

  //////


// Adds + removes active class for swatch slider

function siblings(elem) {
  const nodes = [...elem.parentNode.children]
  return nodes.filter(node => node !== elem)
}

function toggleClass(elem, cls) {
  elem.classList.toggle(cls);
  siblings(elem).forEach(node => {
    node.classList.remove(cls)
  })
}

swatches.forEach(el => {
  el.addEventListener('click', function() {
    toggleClass(this, 'active')
  })
})
//////////////////////////////////////////////////
//////////////////////////////////////////////////

//


document.querySelectorAll(".snap-section").forEach((section, i) => {
  ScrollTrigger.create({
    trigger: section,
    onEnter: () => {goToSection(section, i)},
  });
  
  ScrollTrigger.create({
    trigger: section,
    start: "bottom bottom",
    onEnterBack: () => goToSection(section, i),
  });
});
    
//////////////////////////////////////////////////
//////////////////////////////////////////////////

//

ScrollTrigger.create({
  trigger: ".chair-slider",
  // markers: true,
  start: "top center",
  end: "bottom center",
  toggleClass: {targets: ".header, .dot.is-selected, .dot, .flickity-button-icon", className: "is-light"}  
});

// ScrollTrigger.create({
//   trigger: '.scroller',
//   start: 'top top',
//   animation: chairRotationTl,
//   end: 'bottom bottom',
//   pin: '.pinned-object',
//   pinType: "fixed",
//   pinSpacing: true
// })

// ////// start chair animation

//   const canvas = document.getElementById("hero-lightpass");
//   const context = canvas.getContext("2d");

//   canvas.width = 1920;
//   canvas.height = 1080;

//   const frameCount = 118;
//   const currentFrame = index => (
//     `https://cpat.steelcase.com/7153/loop-v4/stc_5395_banner-loop_20210915g_${(index + 1).toString().padStart(3, '0')}.jpg`
//   );

//   const images = []
//   const chairs = {
//     frame: 0
//   };

//   for (let i = 0; i < frameCount; i++) {
//     const img = new Image();
//     img.src = currentFrame(i);
//     images.push(img);
//   }

//   let chairRotationTl = gsap.timeline({
//     scrollTrigger: {
//       scrub: 0.5,
//       trigger: ".lottie-chair",
//       start: "top 90%",
//       end: "bottom bottom",
//       timescale: 10,
//     },
//   });

//   chairRotationTl.to(chairs, {
//     frame: 11,
//     snap: "frame",
//     duration: 0.5,
//     onUpdate: render,
//     ease: "none"
//   }, "+=0.5")
//   .to(chairs, {
//     frame: 44,
//     snap: "frame",
//     duration: 0.5,
//     onUpdate: render,
//     ease: "none"
//   }, "+=0.5")
//   .to(chairs, {
//     frame: 65,
//     snap: "frame",
//     duration: 0.5,
//     onUpdate: render,
//     ease: "none"
//   }, "+=0.5")
//   .to(chairs, {
//       frame: frameCount - 1,
//       ease: "none",
//       snap: "frame",
//       duration: 0.5,
//       onUpdate: render
//     }, "+=0.5");

//   images[0].onload = render;

//   function render() {
//     context.clearRect(0, 0, canvas.width, canvas.height);
//     context.drawImage(images[chairs.frame], 0, 0);
//   }

//   let textTl = gsap.timeline({
//     scrollTrigger: {
//       scrub: 0.5,
//       trigger: ".lottie-chair__hero",
//       start: "top 85%",
//       end: "bottom bottom",
//     }
//   }).from(".lottie-chair__hero", {opacity:0, display: 'none'})
//      .from(".lottie-title-1, .lottie-title-2, .lottie-title-3", {y:30, opacity:0, autoAlpha:0, stagger: {amount: .3}}, "+=.5" )
//      .to(".lottie-chair__callout--1", {opacity: 1, visibility: 'visible'}, "+=.5" )
//      .to(".lottie-chair__callout--1", {opacity: 0})
//      .from(".lottie-title-4, .lottie-title-5, .lottie-title-6", {y:30, opacity:0, autoAlpha:0, stagger: {amount: .3}}, "+=.5" )
//      .to(".lottie-chair__callout--2", {opacity: 1, visibility: 'visible'}, "+=.5" )
//      .to(".lottie-chair__callout--2", {opacity: 0})
//      .from(".lottie-title-7, .lottie-title-8, .lottie-title-9", {y:30, opacity:0, autoAlpha:0, stagger: {amount: .3}}, "+=.5" )
//      .to(".lottie-chair__callout--3", {opacity: 1, visibility: 'visible'}, "+=.5" )
//      .to(".lottie-chair__callout--3", {opacity: 0})
//      .to(".hidden-link", {display: 'none'})

// /////////////

// ScrollTrigger.create({
//   trigger: ".pinned-slider-scroller",

//   pinType: "fixed",
//   start: "top top",
//   end: "bottom bottom",
//   pin: ".pinned-slider-object", 
//   // pinSpacing: true,
//   // markers: true
// });

// let slides = gsap.utils.toArray(".go-beyond__slide"),
//   currentSection = slides[0];

// gsap.defaults({overwrite: 'auto', duration: 0.3});

//   slides.forEach((section, i) => {
//     ScrollTrigger.create({
//       trigger: `.pinned-scroller-trigger--${i}`,
//       start: "top center",
//       onToggle: self => self.isActive && setSection(section, i)
//     });
//   });
  
//   function setSection(newSection, i) {
//     let counter = document.querySelector('.counter--current')
//     let currentCount = i + 1;

//     const counterText = counter.innerHTML;
//     counter.textContent = currentCount;
    
//     if (newSection !== currentSection) {

//       gsap.to(currentSection, {scale: 1, autoAlpha: 0, duration: .5})

//         gsap.to(newSection, {scale: 1, autoAlpha: 1, duration: .5});
//       currentSection = newSection;
//     }
//   }

//   //

  
//   ScrollTrigger.create({
//     start: "top center",
//     end: "bottom bottom",
//     trigger: '.pinned-slider-scroller',     
//   });

  //

  const showAnim = gsap.from('.header', { 
    yPercent: -100,
    paused: true,
    duration: 0.2
  }).progress(1);

  ScrollTrigger.create({
    start: 'top -80',
    end: 99999,
    toggleClass: {className: 'header__outer--scrolled', targets: '.header__outer'}
  });
  

var testimonialSlider = document.querySelector('.go-beyond__carousel');
var initTestimonialSlider = new Flickity( testimonialSlider, {
  fade: true,
  cellAlign: 'left',
  prevNextButtons: true,
  wrapAround: true,
});

//////

var testimonialSlider = document.querySelector('.go-beyond__carousel');
var initTestimonialSlider = new Flickity( testimonialSlider, {
  fade: true,
  cellAlign: 'left',
  prevNextButtons: true,
  wrapAround: true,
});

var featuredeSlider = document.querySelector('.feature-slider__slider');
var initFeaturedeSlider = new Flickity( featuredeSlider, {
  fade: true,
  cellAlign: 'left',
  prevNextButtons: true,
  wrapAround: true,
});